import React from "react";
import { useAuth } from "../../../api/services/auth";
import { userRoles } from "../../../enums";
import AssistantNav from './assistantNav';
import ConsultantNav from './consultantNav';
import HodNav from './hodNav';
import AdminNav from "./adminNav";
import AuditorNav from "./auditorNav";

const Sidebar = (props) => {
    const { permission, user } = useAuth();

    return (
        <aside className="peermed-sidebar fixed top-14 bottom-0 left-0 z-30 w-56 overflow-x-hidden overflow-y-auto border-r border-parch-100 bg-white py-3">
            <nav className="space-y-0.5 px-2 text-ink-600">
                {
                    user.type === userRoles.ASSISTANT ?
                        <AssistantNav permission={permission} /> :
                    user.type === userRoles.CONSULTANT ?
                        <ConsultantNav /> :
                    user.type === userRoles.HOD ?
                        <HodNav /> :
                    user.type === userRoles.SUPER_USER ?
                        <AdminNav /> :
                    user.type === userRoles.AUDITOR &&
                        <AuditorNav />
                }
            </nav>
        </aside>
    );
}

export default Sidebar;
